import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ProcessingProvider } from './contexts/ProcessingContext';
import { Toaster } from './components/ui/sonner';
import Layout from './components/Layout';

import Home from './pages/Home';
import Login from './pages/Login';
import CompleteProfile from './pages/CompleteProfile';
import Dashboard from './pages/Dashboard';
import Editor from './pages/Editor';
import KaraokePlayer from './pages/KaraokePlayer';
import Settings from './pages/Settings';
import ApiDocs from './pages/ApiDocs';
import Admin from './pages/Admin';

import './App.css';

function ProtectedRoute({ children, skipProfileCheck = false }) {
  const { user, loading, profileComplete } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <img src="/logo.png" alt="Loading" className="h-12 w-12 mx-auto animate-pulse" />
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!skipProfileCheck && !profileComplete) {
    return <Navigate to="/complete-profile" replace />;
  }

  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <img src="/logo.png" alt="Loading" className="h-12 w-12 mx-auto animate-pulse" />
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <ProcessingProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/complete-profile" element={<ProtectedRoute skipProfileCheck={true}><CompleteProfile /></ProtectedRoute>} />
            
            <Route path="/dashboard" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
            <Route path="/editor/:sessionId" element={<ProtectedRoute><Layout><Editor /></Layout></ProtectedRoute>} />
            <Route path="/sing/:sessionId" element={<ProtectedRoute><KaraokePlayer /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
            <Route path="/api-docs" element={<ProtectedRoute><Layout><ApiDocs /></Layout></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><Layout><Admin /></Layout></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" />
        </Router>
      </ProcessingProvider>
    </AuthProvider>
  );
}

export default App;
